import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Merchant } from "../../common/types";
import { useTranslation } from "react-i18next";

interface TransfertData {
  selectedMerchant: Merchant | null;
  amount: number;
  paymentReference: string;
}

interface TransfertDetailProps {
  transfertData: TransfertData;
  onDataChange: (data: Partial<TransfertData>) => void;
}

const TransfertDetail: React.FC<TransfertDetailProps> = ({
  transfertData,
  onDataChange
}) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState<string>(transfertData.amount?.toString() || "");
  const [reference, setReference] = useState<string>(transfertData.paymentReference || "");

  useEffect(() => {
    setAmount(transfertData.amount?.toString() || "");
  }, [transfertData.amount]);

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Regex pour accepter seulement les nombres entiers positifs
    const numberRegex = /^\d*$/;
    
    if (numberRegex.test(value) || value === "") {
      setAmount(value);
      onDataChange({ amount: parseInt(value) || 0 });
    }
  };

  const handleReferenceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setReference(value);
    onDataChange({ paymentReference: value });
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <TextField
        size="small"
        label={t("transfertDetail.merchantLabel")}
        value={transfertData.selectedMerchant?.name || ""}
        disabled
        fullWidth
      />
      <TextField
        size="small"
        label={t("transfertDetail.referenceLabel")}
        value={reference || ""}
        onChange={handleReferenceChange}
        placeholder={t("transfertDetail.referencePlaceholder")}
        fullWidth
      />
      <TextField 
        size="small" 
        label={t("transfertDetail.amountLabel")}
        type="number" 
        fullWidth 
        value={amount}
        onChange={handleAmountChange}
        placeholder={t("transfertDetail.amountPlaceholder")}
        error={transfertData.amount <= 0 && amount !== ""}
        helperText={transfertData.amount <= 0 && amount !== "" ? t("transfertDetail.amountValidationError") : ""}
      />
    </div>
  );
};

export default TransfertDetail;